// Stub — Capacitor native notification APIs are no longer available after the
// Expo WebView pivot.  All methods are safe no-ops.  Server-side push
// notifications are handled by the WITAL backend + APNs (issue #5).

export interface NotificationSettings {
  enabled: boolean
  hour: number
  minute: number
}

class IOSNotificationService {
  async registerPushToken(): Promise<void> {}
  async requestPermission(): Promise<boolean> { return false }
  async checkPermissionStatus(): Promise<'granted' | 'denied' | 'prompt'> { return 'denied' }
  async scheduleTestNotification(_location: string, _language?: string, _type?: 'today' | 'tomorrow'): Promise<void> {}
  async scheduleNotification(_type: 'today' | 'tomorrow', _settings: NotificationSettings, _location: string, _language?: string): Promise<void> {}
  async cancelNotification(_type: 'today' | 'tomorrow'): Promise<void> {}
  async cancelAllNotifications(): Promise<void> {}
  async getPendingNotifications(): Promise<any[]> { return [] }
  async clearBadge(): Promise<void> {}
  setupNotificationHandlers(): void {}
}

export const iosNotificationService = new IOSNotificationService()
